/**
 * Interactive mega menu: hover collection links → swap up to 3 featured cards.
 * data-preview-trigger: static | second | third
 * Open state from Liquid (data-initial-*). Empty image source → hide featured.
 */
(function () {
  var FADE_MS = 40;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function normalizeTrigger(value) {
    if (value === 'l1' || value === 'static') return 'static';
    if (value === 'l3' || value === 'third') return 'third';
    return 'second';
  }

  function applyCard(card, payload) {
    if (!card) return;

    var title = (payload && payload.title) || '';
    var caption = (payload && payload.caption) || (title ? 'Explore ' + title : '');
    var url = (payload && payload.url) || '';
    var image = (payload && payload.image) || '';

    // Card slot only shows when there is an image
    if (!image) {
      card.hidden = true;
      card.classList.add('mega-feature-card--empty');
      return;
    }

    card.hidden = false;
    card.removeAttribute('hidden');
    card.classList.remove('mega-feature-card--empty');

    var titleEl = card.querySelector('[data-mega-card-title]');
    var captionEl = card.querySelector('[data-mega-card-caption]');
    var media = card.querySelector('[data-mega-card-media]');
    var img = card.querySelector('.mega-feature-card__img');
    var fallback = card.querySelector('[data-mega-card-fallback]');
    var fallbackTitle = card.querySelector('[data-mega-card-fallback-title]');

    if (titleEl) titleEl.textContent = title;
    if (captionEl) captionEl.textContent = caption;
    if (url) {
      card.setAttribute('href', url);
      card.removeAttribute('aria-disabled');
    }

    if (img) {
      img.src = image;
      img.removeAttribute('hidden');
      img.alt = title || '';
      if (fallback) fallback.hidden = true;
      if (media) {
        media.classList.remove('mega-feature-card__media--fallback');
        media.style.backgroundColor = '';
      }
      img.onerror = function () {
        card.hidden = true;
        card.classList.add('mega-feature-card--empty');
      };
    }
  }

  function clearFeatured(featured) {
    if (!featured) return;
    featured.hidden = true;
    featured.setAttribute('hidden', '');
    featured.classList.add('mega-menu-featured--empty');
    featured.querySelectorAll('[data-mega-card]').forEach(function (card) {
      card.hidden = true;
      card.setAttribute('hidden', '');
      card.classList.add('mega-feature-card--empty');
      card.classList.remove('is-fading');
      var img = card.querySelector('.mega-feature-card__img');
      var captionEl = card.querySelector('[data-mega-card-caption]');
      var titleEl = card.querySelector('[data-mega-card-title]');
      if (img) {
        img.removeAttribute('src');
        img.setAttribute('hidden', '');
      }
      if (captionEl) captionEl.textContent = '';
      if (titleEl) titleEl.textContent = '';
    });
  }

  function applyPayloads(featured, payloads) {
    if (!featured) return;
    var cards = featured.querySelectorAll('[data-mega-card]');
    var anyImage = false;
    for (var i = 0; i < payloads.length; i++) {
      if (payloads[i] && payloads[i].image) {
        anyImage = true;
        break;
      }
    }
    if (!anyImage) {
      clearFeatured(featured);
      return;
    }
    featured.hidden = false;
    featured.removeAttribute('hidden');
    featured.classList.remove('mega-menu-featured--empty');
    cards.forEach(function (card, idx) {
      applyCard(card, payloads[idx] || null);
    });
  }

  function payloadsFromLink(link) {
    var fallbackTitle = link.getAttribute('data-preview-title') || '';
    var fallbackCaption = link.getAttribute('data-preview-caption') || '';
    var fallbackUrl = link.getAttribute('data-preview-url') || link.getAttribute('href') || '';
    var payloads = [];
    for (var i = 1; i <= 3; i++) {
      var image = link.getAttribute('data-preview-image-' + i) || '';
      if (!image) {
        payloads.push(null);
        continue;
      }
      payloads.push({
        title: link.getAttribute('data-preview-title-' + i) || fallbackTitle,
        caption: link.getAttribute('data-preview-caption-' + i) || fallbackCaption,
        url: link.getAttribute('data-preview-url-' + i) || fallbackUrl,
        image: image
      });
    }
    return payloads;
  }

  function initialPayload(card) {
    return {
      title: card.getAttribute('data-initial-title') || '',
      caption: card.getAttribute('data-initial-caption') || '',
      url: card.getAttribute('data-initial-url') || '',
      image: card.getAttribute('data-initial-image') || ''
    };
  }

  function restoreInitial(featured) {
    if (!featured) return;
    var cards = featured.querySelectorAll('[data-mega-card]');
    var initialCount = parseInt(featured.getAttribute('data-initial-count') || '0', 10);
    if (initialCount <= 0) {
      clearFeatured(featured);
      return;
    }
    var payloads = [];
    cards.forEach(function (card) {
      payloads.push(initialPayload(card));
    });
    applyPayloads(featured, payloads);
  }

  function warmImages(panel) {
    var urls = {};
    panel.querySelectorAll('[data-mega-preview-trigger]').forEach(function (link) {
      for (var i = 1; i <= 3; i++) {
        var src = link.getAttribute('data-preview-image-' + i);
        if (src) urls[src] = true;
      }
    });
    panel.querySelectorAll('[data-mega-card][data-initial-image]').forEach(function (card) {
      var src = card.getAttribute('data-initial-image');
      if (src) urls[src] = true;
    });
    Object.keys(urls).forEach(function (src) {
      var img = new Image();
      img.src = src;
    });
  }

  function bindPanel(panel) {
    if (panel.getAttribute('data-mega-interactive-bound') === 'true') return;
    panel.setAttribute('data-mega-interactive-bound', 'true');

    var trigger = normalizeTrigger(panel.getAttribute('data-preview-trigger') || 'second');
    var featured = panel.querySelector('[data-mega-featured]');
    if (!featured) return;

    var cards = featured.querySelectorAll('[data-mega-card]');
    var timer = null;
    var token = 0;
    var activeLink = null;

    // Hidden mega-menu previews are warmed only when the customer opens the
    // panel. Loading them at DOM ready competes with the hero image and product
    // grid even though the menu may never be used.
    var panelImagesWarmed = false;
    var warmPanelImages = function () {
      if (panelImagesWarmed) return;
      panelImagesWarmed = true;
      warmImages(panel);
    };
    panel.addEventListener('pointerenter', warmPanelImages, { once: true, passive: true });
    panel.addEventListener('focusin', warmPanelImages, { once: true, passive: true });

    if (trigger === 'static') return;

    function handlePreviewLink(link) {
      if (!link || activeLink === link) return;
      activeLink = link;
      if (timer) clearTimeout(timer);

      var payloads = payloadsFromLink(link);
      var anyImage = payloads.some(function (p) {
        return p && p.image;
      });
      var markedEmpty = link.getAttribute('data-preview-empty') === 'true';

      // Empty metafield / no images → clear previous collection preview immediately
      if (markedEmpty || !anyImage) {
        token += 1;
        clearFeatured(featured);
        return;
      }

      var current = ++token;
      cards.forEach(function (card) {
        card.classList.add('is-fading');
      });

      timer = setTimeout(function () {
        if (current !== token) return;
        applyPayloads(featured, payloads);
        cards.forEach(function (card) {
          card.classList.remove('is-fading');
        });
      }, FADE_MS);
    }

    // Event delegation: catch every trigger link, including empty-metafield collections
    panel.addEventListener('mouseover', function (event) {
      var link = event.target.closest('a[data-mega-preview-trigger]');
      if (!link || !panel.contains(link)) return;
      handlePreviewLink(link);
    });

    panel.addEventListener('mouseleave', function () {
      if (timer) clearTimeout(timer);
      token += 1;
      activeLink = null;
      restoreInitial(featured);
      cards.forEach(function (card) {
        card.classList.remove('is-fading');
      });
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.mega-menu--interactive').forEach(bindPanel);
  }

  ready(function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
